import { getUserPrompt, setUserPrompt } from '@/pages/opinion/services';
import { useState } from 'react';

export default function useGptHistoryPrompt({ gameInfo, promptList }: any) {
  const [userPromptList, setUserPromptList] = useState<
    Array<{ prompt_detail: string; update_time: string }>
  >([]);
  const [loading, setLoading] = useState(false);

  const getUserHistoryPrompt = () => {
    if (gameInfo?.edition_unified_id) {
      setLoading(true);
      getUserPrompt({
        edition_unified_id: gameInfo.edition_unified_id,
        page: 1,
        page_size: 5,
      })
        .then(data => {
          setUserPromptList(data || []);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  function checkSamePromptList(promptText: string) {
    if (promptList && promptList.length > 0) {
      const text = promptText.trim();
      const samePrompt = promptList.find(
        (item: any) => item['en-US'] === text || item['zh-CN'] === text,
      );
      if (samePrompt) {
        return true;
      }
    }

    return false;
  }

  const setUserHistoryPrompt = (value: string, id?: string) => {
    if (checkSamePromptList(value)) {
      return;
    }

    if (!value) {
      return;
    }

    setUserPrompt({
      edition_unified_id: gameInfo.edition_unified_id,
      prompt: value,
      id,
    });
  };

  return {
    loading,
    userPromptList,
    setUserHistoryPrompt,
    getUserHistoryPrompt,
  };
}
